import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row, Col } from 'react-flexbox-grid';

const propTypes = {
  settings: PropTypes.instanceOf(Map).isRequired,
};

function NoEvents({ settings }) {
  return (
    <Row>
      <Col xs={12} className="no-events">
        {settings.get('noEventsText')}
      </Col>
    </Row>
  );
}

NoEvents.propTypes = propTypes;

export default NoEvents;



// WEBPACK FOOTER //
// ./src/widget/no_events.js